export default "__VITE_ASSET__C3ARyJf9__"